import { menuAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(menuAnatomy.keys);

const baseStyle = definePartsStyle({
  button: {
    _dark: {
      bg: "black.700",
    },
    _active: {
      _dark: {
        bg: "black.700",
      },
    },
  },
  list: {
    _dark: {
      bg: "black.700",
    },
  },
});

export const Menu = defineMultiStyleConfig({
  baseStyle,
  defaultProps: {},
});
